import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Menu } from '../models/menu.model';
import { CaseMenuAction } from '../dg_core/dg-case-view/case.constants';
import { SelectCaseDialogComponent } from '../dg_core/actions/selectCaseDialog/select-case-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { DgReopenComponent } from '../dg_core/dg-actions/dg-reopen/dg-reopen.component';
import { post } from 'jquery';

@Injectable({
  providedIn: 'root',
})
export class CaseService {
  refreshCaseSubject = new BehaviorSubject<number>(null);
  private gridSubject = new Subject<{
    refreshGrid: boolean;
    closeTabs: number[];
  }>();
  public gridSubject$ = this.gridSubject.asObservable();

  private saveParentSubject = new Subject<void>();
  private saveParentFlag = false;
  saveParent$ = this.saveParentSubject.asObservable();
  constructor(
    private http: HttpClient,
    private dialog: MatDialog,
    private translate: TranslateService
  ) {}
  getCaseActions(
    privId: number,
    appTypeId?: number,
    docId?: number,
    subjectId?: number
  ): Observable<Menu[]> {
    let params = new HttpParams().append('previlageId', privId.toString());
    if (appTypeId) {
      params = params.append('appTypeId', appTypeId);
    }
    if (docId) {
      params = params.append('docId', docId);
    }
    if (subjectId) {
      params = params.append('subjectId', subjectId);
    }
    return this.http.get<Menu[]>(`/access-control/user-privileges`, {
      params: params,
    });
  }

  triggerSaveParent() {
    if (!this.saveParentFlag) {
      this.saveParentFlag = true;
      this.saveParentSubject.next();
    }
  }

  triggerRefreshParent(caseDetails) {
    this.refreshCaseSubject.next(caseDetails.fileId);
  }

  resetSaveParentFlag() {
    this.saveParentFlag = false;
  }

  onCaseMenuClick(menu: Menu, caseDetailsList: any[], dataForPost?) {
    //DATA FOR POST SHOULD NOT COME FROM COMPONENTN AS OF NOW USING IT WILL DO REFACTOR AFTER
    switch (menu.privId) {
      case CaseMenuAction.SAVE:
        this.onCaseSave(dataForPost, dataForPost?.openFrom ?? null).subscribe(
          () => {
            this.refreshCaseSubject.next(caseDetailsList[0].fileId);
          }
        );
        break;
      case CaseMenuAction.MOVE_TO_WORKLIST_INSIDE:
        this.openCaseActionDialog(menu, caseDetailsList, dataForPost);
        break;
    }
  }
  openCaseActionDialog(menu: Menu, caseDetailsList: any[], dataForPost?): void {
    if (this.hasCorrData(caseDetailsList, menu)) {
      const actionComponent: any = this.getActionDialogComponent(menu);
      let dialogData = {
        selectedData: caseDetailsList,
        isFromCustomAction: false,
      };
      const dialogRef = this.dialog.open(actionComponent, {
        data: dialogData,
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.gridSubject.next({
            refreshGrid: true,
            closeTabs: caseDetailsList.map((c) => c?.docId || c?.fileId),
          });
        }
      });
    }
  }
  onAddToMainFile(postData) {
    return this.http.post('/case-mgmnt/add-to-main-file', postData);
  }
  onCaseSave(caseData, openFrom: number = null): Observable<any> {
    let params = new HttpParams();
    if (openFrom) {
      params = params.set('openFrom', 0);
    }
    return this.http.post('/case-mgmnt/action/save', caseData, {
      params: openFrom ? params : null,
    });
  }
  getActionDialogComponent(menu: Menu): any {
    switch (menu.privId) {
      case CaseMenuAction.MOVE_TO_WORKLIST_INSIDE:
        return DgReopenComponent;
    }
  }
  private hasCorrData(caseDetailsList: any[], menu: Menu): boolean {
    if (!caseDetailsList || caseDetailsList?.length === 0) {
      const errorMsg = this.translate.instant('select_Case_Dialog.Select_case');
      this.dialog.open(SelectCaseDialogComponent, { data: errorMsg });
    }
    return caseDetailsList && caseDetailsList?.length > 0;
  }

  addPreferredList(
    groupName,
    groupShortName,
    groupDescription,
    preferredListEmps
  ): Observable<any> {
    let dataForPost = {
      groupName: groupName,
      groupShortName: groupShortName,
      groupDescription: groupDescription,
      empId: preferredListEmps.map((emp) => emp['EMP_ID']),
    };

    return this.http.post('/case-mgmnt/add-group ', dataForPost);
  }

  updatePreferredList(groupId, srNo, formValue, activeFlag): Observable<any> {
    //groupName, preferredListEmps
    let dataForPost = {
      groupId: groupId,
      srIdPk: srNo,
      groupName: formValue.groupName,
      groupShortName: formValue.groupShortName,
      groupDescription: formValue.groupDescription,
      activateFlag: activeFlag,
      empId: formValue.preferredListEmps.map((emp) => emp['EMP_ID']),
    };

    return this.http.put('/case-mgmnt/update-group ', dataForPost);
  }

  fetchPreferredListById(groupId): Observable<any> {
    let dataForPost = {
      groupId: groupId,
    };
    return this.http.post('/case-mgmnt/group-details', dataForPost);
  }
}
